import { useState, useEffect } from 'react';

export const useCustomOrderPersistence = (initialState) => {
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem('customOrderFormData');
    return saved ? JSON.parse(saved) : initialState;
  });

  useEffect(() => {
    localStorage.setItem('customOrderFormData', JSON.stringify(formData));
  }, [formData]);

  const clearFormData = () => {
    localStorage.removeItem('customOrderFormData');
    setFormData(initialState);
  };

  return [formData, setFormData, clearFormData];
};